export const isMobileLandscape = (): boolean => {
  // 新版浏览器可使用 window.screen.orientation
  if (window.screen.orientation) {
    const { type } = window.screen.orientation;
    if (type.includes("landscape")) {
      return true;
    }
  } else {
    // 兼容老版本
    if (window.orientation === 180 || window.orientation === 0) {
      return false;
    }
    // 横屏状态
    if (window.orientation === 90 || window.orientation === -90) {
      return true;
    }
  }
  return false;
};

// 如果是移动端横屏状态，isPC会返回true。增加isPure参数，用来判断纯正的PC端
export const isPC = (isPure: boolean = false): boolean => {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = isPure ? false : isMobileLandscape();
      break;
    }
  }
  return flag;
};

export const removeQueryParam = (url: string, key: string) => {
  // 使用正则表达式匹配查询参数
  const pattern = new RegExp(`[?&]${encodeURIComponent(key)}=([^&]*)`);
  const match = url.match(pattern);

  // 如果没有匹配到，直接返回原URL
  if (!match) {
    return url;
  }

  // 删除匹配到的查询参数及其值
  const newUrl = url.replace(pattern, "");

  // 如果新URL还有查询参数，确保前缀是?而不是&
  return newUrl.startsWith("&") ? newUrl.substring(1) : newUrl;
};

// 复制文本
/**
 * 复制文本到剪贴板
 * @param text 需要复制的文本
 * @returns 返回一个Promise，成功时resolve(true)，失败时reject(error)
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    // 优先使用现代剪贴板API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // 降级方案：使用传统的execCommand方法
      return fallbackCopyTextToClipboard(text);
    }
  } catch (error) {
    console.error("复制文本失败:", error);
    throw error;
  }
}

/**
 * 传统的复制文本方法（兼容方案）
 * @param text 需要复制的文本
 * @returns 是否成功复制
 */
export function fallbackCopyTextToClipboard(text: string): boolean {
  // 创建一个临时textarea元素
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // 避免屏幕闪烁，将元素移出视图
  textArea.style.position = "fixed";
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.opacity = "0";

  document.body.appendChild(textArea);

  // 选中并复制文本
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);
    return successful;
  } catch (error) {
    console.error("传统复制方法失败:", error);
    document.body.removeChild(textArea);
    return false;
  }
}

export function getLevel(num: number): number {
  if (num <= 0) return 0;
  if (num <= 2) return 1;
  if (num < 5) return 2;
  return 3;
}
